import { render } from "./rich-editor.vue?vue&type=template&id=7e82af53&ts=true"
import script from "./rich-editor.vue?vue&type=script&lang=ts"
export * from "./rich-editor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__